var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon",attrs:{"title":_vm.usePixels ? 'Values in pixels (px)' : 'Values in percentage (%)'},on:{"click":function($event){return _vm.$emit('clicked')}}},[_vm._v(" "+_vm._s(_vm.usePixels ? 'px' : '%')+" ")])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }